function l(l){var n;return null===(n=null!=l?l:[])||void 0===n?void 0:n.map((l=>{var n,o;const[i,...u]=null!==(n=null==l?void 0:l.split("."))&&void 0!==n?n:[];return{namespace:i,key:null===(o=null!=u?u:[])||void 0===o?void 0:o.join(".")}}))}export{l as getMetafieldIdentifiers};
//# sourceMappingURL=metafields.js.map
